import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { cva as r } from "class-variance-authority";
import { Field as i } from "@base-ui/react/field";
//#region src/input/textarea.tsx
var a = r([
	"flex w-full items-center rounded-md input-ring transition-base bg-field-bg-primary text-text-primary outline-none text-base px-3 text-ellipsis",
	"placeholder:text-text-tertiary",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled data-disabled:cursor-not-allowed",
	"py-3 h-fit min-h-[82px] resize-none"
], {
	variants: { size: { md: "h-10" } },
	defaultVariants: { size: "md" }
}), o = t(({ className: t, size: r, unstyled: o, rows: s, autoresize: c, ...l }, u) => {
	let d = l;
	return /* @__PURE__ */ n(i.Control, {
		ref: u,
		"data-slot": "textarea-control",
		"data-testid": "textarea-control",
		"data-size": r,
		render: /* @__PURE__ */ n("textarea", { rows: s }),
		className: e(o ? void 0 : a({ size: r }), c && "field-sizing-content h-auto", t),
		...d
	});
});
o.displayName = "Textarea";
//#endregion
export { o as Textarea, a as textareaVariants };
